module.exports = __webpack_public_path__ + "img/zzfWeb.3fc25903.jpg";